import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { Loader2, Lock } from 'lucide-react';
import { toast } from 'sonner';
import SEO from '@/components/SEO';

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    if (user) return <Navigate to="/admin" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success('Dobrodošli!');
            navigate('/admin');
        } catch (err) {
            toast.error(err?.response?.data?.detail || 'Prijava nije uspjela');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <SEO title="Admin prijava | Škobić Keramika" noindex nofollow />
            <div className="min-h-screen flex items-center justify-center bg-[color:var(--sk-bg)] px-4">
                <div className="w-full max-w-md">
                    <div className="text-center mb-8">
                        <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[color:var(--sk-text)] text-white mb-4">
                            <Lock className="h-5 w-5" />
                        </div>
                        <h1 className="font-display text-3xl">Admin prijava</h1>
                        <p className="text-sm text-foreground/65 mt-1">Škobić Keramika – upravljanje sadržajem</p>
                    </div>
                    <Card className="p-6 bg-white" data-testid="admin-login-form">
                        <form onSubmit={onSubmit} className="space-y-4">
                            <div>
                                <Label htmlFor="email">E-mail</Label>
                                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 rounded-xl" data-testid="admin-login-email-input" autoComplete="username" />
                            </div>
                            <div>
                                <Label htmlFor="password">Lozinka</Label>
                                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2 rounded-xl" data-testid="admin-login-password-input" autoComplete="current-password" />
                            </div>
                            <Button type="submit" disabled={loading} className="w-full bg-[color:var(--sk-text)] text-white hover:bg-black rounded-xl h-11" data-testid="admin-login-submit-button">
                                {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Prijava…</> : 'Prijavi se'}
                            </Button>
                        </form>
                    </Card>
                    <p className="text-center text-xs text-foreground/55 mt-6">
                        Pristup samo za autorizirane korisnike.
                    </p>
                </div>
            </div>
        </>
    );
}
